<template>
  <div class="color-legend">
    <div class="legend-section">
      <h4>Formatos (Fondo)</h4>
      <div class="legend-row">
        <div
          v-for="format in availableFormats"
          :key="format"
          class="legend-item"
        >
          <span :class="['legend-color', 'format-' + format]" />
          <span>{{ getFormatLabel(format) }}</span>
        </div>
      </div>
    </div>
    <div class="legend-section">
      <h4>Envases (Borde)</h4>
      <div class="legend-row">
        <div
          v-for="packaging in availablePackagings"
          :key="packaging"
          class="legend-item"
        >
          <span :class="['legend-color', 'packaging-' + packaging]" />
          <span>{{ getPackagingLabel(packaging) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
export default {
  name: 'CalendarLegend',
  props: {
    availableFormats: {
      type: Array,
      default: () => [],
    },
    availablePackagings: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getFormatLabel(format) {
      const labels = {
        entero: 'Entero',
        harinado: 'Harinado',
        multiparticle: 'Multipartícula',
        pelet_3: 'Pelet 3',
        pelet_6: 'Pelet 6',
        pelet_8: 'Pelet 8',
        pelet_12: 'Pelet 12',
      };

      return labels[format] || 'Otro';
    },
    getPackagingLabel(packaging) {
      const labels = {
        granel: 'Granel',
        ensacado: 'Ensacado',
        maxisaco: 'Maxisaco',
      };

      return labels[packaging] || 'Otro';
    },
  },
};
</script>

<style scoped>
.color-legend {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.legend-section {
  text-align: center;
}

.legend-section h4 {
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 14px;
}

.legend-row {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: 12px;
  color: #2c3e50;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid #ddd;
}

/* Colores de formato (fondo) */
.legend-color.format-entero { background: #56B686; }
.legend-color.format-harinado { background: #D85796; }
.legend-color.format-multiparticle { background: #3076EE; }
.legend-color.format-pelet_3 { background: #E31431; }
.legend-color.format-pelet_6 { background: #E87B37; }
.legend-color.format-pelet_8 { background: #845FEF; }
.legend-color.format-pelet_12 { background: #EBA23D; }

/* Colores de empaque (borde) */
.legend-color.packaging-granel { background: #ffffff; border-left: 8px solid #020405; }
.legend-color.packaging-ensacado { background: #ffffff; border-left: 8px solid #4CE51E; }
.legend-color.packaging-maxisaco { background: #ffffff; border-left: 8px solid #0CEEE7; }
</style>
